import {useQueryClient} from 'react-query'

type AccessResult = 'none' | 'view' | 'edit'

interface NavNode {
  code: string
  accessLevel?: number | null
  children?: NavNode[]
}

const findByCode = (nodes: NavNode[], code: string): NavNode | undefined => {
  for (const n of nodes) {
    if (n.code === code) return n
    if (n.children?.length) {
      const found = findByCode(n.children, code)
      if (found) return found
    }
  }
  return undefined
}

export const useFeatureAccess = (featureCode: string): AccessResult => {
  const queryClient = useQueryClient()
  const nav = queryClient.getQueryData<NavNode[]>('my-navigation')

  if (!nav) return 'edit'

  const node = findByCode(nav, featureCode)
  if (!node) return 'edit'

  if (node.accessLevel === 1) return 'view'
  if (node.accessLevel === 2) return 'edit'

  return 'edit'
}
